import axiosInstance from "../../config/axiosInstance";
const getRoles = async ({ hasAdmin }: { hasAdmin: boolean }) => {
  const { data } = await axiosInstance.get<{
    roles: { id: number; name: string }[];
  }>(`/api/roles`);
  return { data, hasAdmin };
};

const getSectors = async ({
  hasAdmin,
  gpLeadSectors,
}: {
  hasAdmin: boolean;
  gpLeadSectors: string[];
}) => {
  const { data } = await axiosInstance.get<{
    sectors: { id: number; name: string }[];
  }>(`/api/sectors`);
  return { data, hasAdmin, gpLeadSectors };
};

const getPregeneratedQuestions = async () => {
  const { data } = await axiosInstance.get<{ pregeneratedQuestions: string }>(
    `/api/pregenerated-questions`
  );
  return data;
};

const sendAppFeedback = async (feedback: any) => {
  const response = await axiosInstance.post("/api/appfeedback", feedback);
  return response.data;
};

const appDataService = {
  getRoles,
  getSectors,
  getPregeneratedQuestions,
  sendAppFeedback,
};
export default appDataService;
